<template lang="html">
<div>
  <div v-if="errors.length > 0">
    <b-alert show variant="danger" v-bind:key="index" v-for="(error, index) in errors">
      {{ error }}
    </b-alert>
  </div>
  <b-form-group label="Name" label-for="name">
    <b-form-input id="name" placeholder="Name on card" autocomplete="cc-name" maxlength="100" v-model="name"></b-form-input>
  </b-form-group>
  <b-form-group class="pt-1" label="Credit Card" label-for="card">
    <div id="card" ref="card" class="form-control stripe-card"></div>
  </b-form-group>
  <b-button class="mt-2" :variant="submitVariant" @click="createToken">{{submitText}}</b-button>
</div>

</template>

<script>
var stripe = window.Stripe(process.env.VUE_APP_STRIPE_PUBLIC_KEY)
const STYLE = {
  base: {
    color: '#32325d',
    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
    fontSmoothing: 'antialiased',
    fontSize: '16px',
    '::placeholder': {
      color: '#aab7c4'
    }
  },
  invalid: {
    color: '#fa755a',
    iconColor: '#fa755a'
  }
}

export default {
  props: {
    submitText: {
      type: String,
      required: false,
      default: 'Add'
    },
    submitVariant: {
      type: String,
      required: false,
      default: 'warning'
    }
  },
  data () {
    return {
      errors: [],
      success: false,
      name: ''
    }
  },
  mounted () {
    // Stripe's card field is an iframe, out of reach of the page's CSS. A form
    // can still set its text colour by defining --stripe-input-color on an
    // ancestor, e.g. a dark form.
    const color = getComputedStyle(this.$el).getPropertyValue('--stripe-input-color').trim()
    const base = color ? { ...STYLE.base, color } : STYLE.base
    // Each form gets its own card Element (kept off the reactive data).
    this.card = stripe.elements().create('card', { style: { ...STYLE, base } })
    this.card.mount(this.$refs.card)
  },
  beforeDestroy () {
    clearTimeout(this.resetTimer)
    if (this.card) this.card.destroy()
  },
  methods: {
    createToken () {
      stripe.createToken(this.card, { name: this.name }).then(
        (result) => {
          if (result.token) {
            this.$emit('tokenCreated', result.token)
            this.success = true
            this.resetTimer = setTimeout(() => {
              this.success = false
              this.card.clear()
              this.name = ''
            }, 2000)
          } else {
            this.errors = []
            let error = result.error.message || 'There was an error verifying this card'
            this.errors.push(error)
          }
        }
      )
    }
  }
}
</script>

<style lang="css">
</style>
